import { IApplicationState } from '../../types/redux';

export function getIsAuthenticated(state: IApplicationState) {
  return state.user.isAuthenticated;
}
